import React from 'react';
import {
    DeleteButton,
    ListButton,
    SaveButton,
    SimpleForm as RaSimpleForm,
    Toolbar as RaToolbar,
} from 'react-admin';

const Toolbar = () => {
    return (
        <RaToolbar sx={{ display: 'flex', alignItems: 'center' }}>
            <SaveButton />
            <ListButton sx={{ marginLeft: 2 }} />
            <DeleteButton sx={{ marginLeft: 'auto' }} />
        </RaToolbar>
    );
};

export const SimpleForm = ({ children }: { children: React.ReactNode }) => {
    return (
        <RaSimpleForm sanitizeEmptyValues toolbar={<Toolbar />}>
            {children}
        </RaSimpleForm>
    );
};
